const destroyFns: Function[] = [];
export default destroyFns;
